// toGetCurrentRegistration.js

export default {
  state: {
    SetRegistration_info_item: {
      basic_json: '{}',
      formRegistrationInfo: {},
      contact_person_json: '{}',
      formContactPerson: {},
      retinue_json: '[]',
      formRetinueInfo: [],
      hotel_json: '{}',
      formHotelInfo: {},
      travel_json: '{}',
      formTravelInfo: {},
      reception_json: '{}',
      formReceptionInfo: {},
    },
    registration_status: null,
  },
  mutations: {
    AddCurrentRegistration(state, payload) {
      state.SetRegistration_info_item = payload;
    },
    AddCurrentRegistrationState(state, payload) {
      state.registration_status = payload;
    },
  },
  actions: {},
};
